import type { ReactNode } from "react";
import { NavLink } from "react-router-dom";
import { LogOut, LayoutDashboard, SlidersHorizontal, Settings as SettingsIcon } from "lucide-react";
import { useAuth } from "../lib/auth.js";
import { Wordmark } from "./brand/Logo.js";

const navItems = [
  { to: "/", label: "Panel", icon: LayoutDashboard, end: true },
  { to: "/preferences", label: "Tercihler", icon: SlidersHorizontal, end: false },
  { to: "/settings", label: "Ayarlar", icon: SettingsIcon, end: false },
];

export function AppShell({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth();

  return (
    <div className="min-h-screen">
      <header className="sticky top-0 z-30 border-b border-slate-800/60 bg-ink-900/80 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
          <Wordmark />

          <nav className="hidden items-center gap-1 sm:flex">
            {navItems.map(({ to, label, icon: Icon, end }) => (
              <NavLink
                key={to}
                to={to}
                end={end}
                className={({ isActive }) =>
                  `inline-flex items-center gap-2 rounded-lg px-3.5 py-2 text-sm transition-colors ${
                    isActive
                      ? "bg-gold/10 text-gold"
                      : "text-slate-400 hover:bg-white/[0.04] hover:text-slate-100"
                  }`
                }
              >
                <Icon className="h-4 w-4" />
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden text-sm text-slate-500 md:inline">{user?.email}</span>
            <button
              onClick={() => signOut()}
              title="Çıkış yap"
              className="inline-flex items-center gap-2 rounded-lg px-3 py-2 text-sm text-slate-400 transition-colors hover:bg-white/[0.04] hover:text-slate-100"
            >
              <LogOut className="h-4 w-4" />
              <span className="hidden sm:inline">Çıkış</span>
            </button>
          </div>
        </div>

        {/* Mobil alt navigasyon */}
        <nav className="flex items-center gap-1 border-t border-slate-800/60 px-4 py-1.5 sm:hidden">
          {navItems.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                `inline-flex flex-1 items-center justify-center gap-2 rounded-lg px-3 py-2 text-sm ${
                  isActive ? "bg-gold/10 text-gold" : "text-slate-400"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              {label}
            </NavLink>
          ))}
        </nav>
      </header>

      <main className="mx-auto max-w-6xl px-6 py-10">{children}</main>
    </div>
  );
}
